module.exports = __webpack_public_path__ + "static/media/HCMM834.ad5254d6.jpg";